import React, {useEffect, useRef} from 'react';
import L from "leaflet";
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen'
import {INVALID_LOCATION, mapCenter} from "../utils/constants";
import {debounce, isMarkerInsidePolygon, LocationObject, parsePolygon} from "../utils/helper";
import swal from "../utils/swal";
import Strings from "../Lang/strings";
import {GeoSearchControl, OpenStreetMapProvider} from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css'
import http from "../http/http";
import {win} from "leaflet/src/core/Browser";


const Map = ({marker, polygon, dataChangeHandler}) => { // marker object contain the polygon also
    const polygonRef = useRef();
    const mapRef = useRef({});
    const markerRef = useRef({});
    if (polygon) {
        var parsedPolygon = parsePolygon(polygon);
        polygonRef.current = L.polygon(parsedPolygon, {color: 'red'});
        markerRef.current = marker;
    }
    useEffect(() => {
        let map = initMap("map", ...mapCenter);
        window.map = map;
        initSearchBox(map);
        // move end event listener to detect marker movements and validate it based the polygon given
        map.on('moveend', () => {
            debounce(500, () => {
                const {lat, lng} = mapRef.current.getCenter();
                if (polygonRef.current) {
                    if (!isMarkerInsidePolygon(lat, lng, polygonRef.current)) {
                        swal(Strings.selectInsidePolygon, "warning")
                            .then(_ => resetMapCenter(map));
                    } else {
                        dataChangeHandler("location", new LocationObject(lat, lng));
                    }
                }
            })
        });

        // detect location from the search and send request to validate that location
        map.on('geosearch/showlocation', function () {
            const {lat, lng} = map.getCenter();
            validateLocation(lat, lng);
        });
    }, []);

    //handle interactions
    useEffect(() => {
        if (marker && polygon) {
            // MAP CHANGE
            mapRef.current.panTo(new L.LatLng(marker.latitude, marker.longitude));
            // remove any other previous polygons if found
            mapRef.current.eachLayer(function (layer) {
                if (layer instanceof L.Polygon) {
                    mapRef.current.removeLayer(layer)
                }
            });
            polygonRef.current.addTo(mapRef.current);
            mapRef.current.dragging.enable()
            // addPolygon(polygon, mapRef.current);
            toggleMapOverlay(false);
        } else if (!marker) {
            getUserLocation();
        }
    }, [polygon]);

    const initMap = (mapId, lat, long) => {
        var map = L.map(mapId, {
                fullscreenControl: true,
                zoomAnimation: true,
                minZoom: 7,
                dragging: false,
                // OR
                // fullscreenControl: {
                //     pseudoFullscreen: false // if true, fullscreen to page width and height
            }
        ).setView([lat, long], 13);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
            maxZoom: 18,
            fullscreenControl: true,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
        }).addTo(map);
        mapRef.current = map;
        return map;
    };
    const getUserLocation = () => {
        toggleMapOverlay();
        window.navigator.geolocation
            .getCurrentPosition(response => {
                window.response = response;
                toggleMapOverlay();
                const userLocation = [response.coords.latitude, response.coords.longitude];
                validateLocation(...userLocation, true);
                mapRef.current.panTo(new L.LatLng(...userLocation));
            }, (e) => {
                // console.log(e)1;
                toggleMapOverlay();
                swal(Strings.locationPermissionDenied, "warning");
            });
    }
    const toggleMapOverlay = (value = null) => {
        let map = document.getElementById("map");
        let className = "map-overlay";
        if (value === true) {
            map.classList.add(className);
        } else if (value === false) {
            map.classList.remove(className)
        } else {
            map.classList.toggle(className)
        }
    };
    const resetMapCenter = (map, autoLocationDetect = false) => {
        let latLngArray;
        latLngArray = autoLocationDetect
            ? [...mapCenter]
            : [markerRef.current.latitude, markerRef.current.longitude];
        const latLngObject = new L.latLng(...latLngArray);
        map.setView(latLngObject)
    }
    const initSearchBox = (map) => {
        const provider = new OpenStreetMapProvider();
        const searchControl = new GeoSearchControl({
            provider: provider,
            style: "bar",
            searchLabel: Strings.searchAddress,
            position: "topright"
        });
        // window.search = searchControl;
        map.addControl(searchControl);
    }
    //auto detection is to validation the location that obtained from the geolocation permission (to display different messages to the user if the location is not valid)
    const validateLocation = (lat, lng, autoLocationDetect = false) => {
        const url = `/lookup/location/${lat}/${lng}/`
        http.get(url).then(response => {
            dataChangeHandler("district_id", response.data.district_id);
            dataChangeHandler("location", {latitude: lat, longitude: lng});
            dataChangeHandler("polygon", response.data.district_polygon);
            dataChangeHandler("city_id", response.data.city_id);
            if (autoLocationDetect) {
                dataChangeHandler("location_auto_detected", true);
            } else {
                dataChangeHandler("location_auto_detected", false)
            }
            toggleMapOverlay(false);
        }).catch(e => {
            if (e.response.status === 404 || e.response.status === 422) {
                if (INVALID_LOCATION.includes(e.response.data.detail)) {
                    if (autoLocationDetect) {
                        console.log("here")
                        swal(Strings.locationFromPermissionNotValid, "warning")
                        resetMapCenter(mapRef.current, true);
                    } else {
                        swal(Strings.locationNotSupported, "warning")
                    }
                    // customerLocationMapRef.current.setView(new L.latLng(...mapDefaultCenter));
                }
            }
        });
    }

    const fixedMarkerStyles = {
        left: "50%",
        top: "50%",
        "marginLeft": "-6px",
        "marginTop": "-43px",
        width: "25px",
        height: "41px",
        zIndex: "600"
    }

    return (
        <>
            <div id={"map"} className="h-full map-overlay relative transition duration-1000 z-0	 transition-all">
                <img id={"fixed-marker"} className={"absolute"} style={fixedMarkerStyles}
                     src="https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png"
                     alt="location marker at the center"/>
            </div>
            {/*<div id="map-loader"*/}
            {/*     className="hidden absolute top-0 items-center  w-full h-full z-50 bg-black flex-col opacity-75 flex items-start justify-center">*/}
            {/*    <div className="loader ease-linear rounded-full border-4 border-t-4  h-16 w-16 mb-4"></div>*/}
            {/*    <h2 className="text-center text-white text-base lg:text-2xl font-semibold">{Strings.loadingYourLocation}</h2>*/}
            {/*</div>*/}
            <div>
                <button
                    onClick={getUserLocation}
                    className="talabatey-outline  text-xs mt-2 text-zain-primary capitalize border-2 border-zain-primary hover:text-white  rounded-full hover:bg-zain-primary transition block mx-auto px-4 py-1.5"
                    type="button">{Strings.autoLocationSelect}</button>

            </div>
        </>
    );
};


export default Map;
